import routes from "@/routes";
import { lazy } from "react";

const ListScheduledReports = lazy(
  () => import("@/modules/ScheduledReports/ListScheduledReports")
);

const ScheduledReportsRoutes = {
  element: <ListScheduledReports />,
  path: routes.SCHEDULED_REPORTS.INDEX,
};

export default ScheduledReportsRoutes;
